import type { PlaceObject } from '../types';

// Map Google Place primaryType to human-readable category
export const PLACE_CATEGORY_MAP: Record<string, string> = {
  restaurant: 'Restaurants',
  fine_dining_restaurant: 'Restaurants',
  food: 'Restaurants',
  cafe: 'Cafes',
  coffee_shop: 'Cafes',
  bar: 'Bars',
  night_club: 'Bars',
  hotel: 'Hotels',
  lodging: 'Hotels',
  motel: 'Hotels',
  resort_hotel: 'Hotels',
  hostel: 'Hotels',
  museum: 'Museums',
  art_gallery: 'Museums',
  tourist_attraction: 'Attractions',
  amusement_park: 'Attractions',
  zoo: 'Attractions',
  aquarium: 'Attractions',
  park: 'Parks',
  national_park: 'Parks',
  garden: 'Parks',
  store: 'Shopping',
  shopping_mall: 'Shopping',
  clothing_store: 'Shopping',
  church: 'Landmarks',
  mosque: 'Landmarks',
  synagogue: 'Landmarks',
  hindu_temple: 'Landmarks',
  place_of_worship: 'Landmarks',
  spa: 'Wellness',
  gym: 'Wellness',
  beauty_salon: 'Wellness',
};

// Category grouping order for folder grouping (matches inline categoryOrder).
export const CATEGORY_ORDER = ['Restaurants', 'Cafes', 'Bars', 'Hotels', 'Museums', 'Attractions', 'Parks', 'Shopping', 'Landmarks', 'Wellness', 'Other'];

export function getPlaceCategory(primaryType?: string, place?: PlaceObject): string {
  // 1. Check primaryType from Google
  if (primaryType && PLACE_CATEGORY_MAP[primaryType]) {
    return PLACE_CATEGORY_MAP[primaryType];
  }
  if (!place) return 'Other';
  // 2. Infer from amenities in sections
  const amenities = place.sections?.find(s => s.title === 'Amenities')?.items || [];
  const amenityStr = amenities.join(' ').toLowerCase();
  if (amenityStr.includes('lodging')) return 'Hotels';
  if (amenityStr.includes('restaurant')) return 'Restaurants';
  if (amenityStr.includes('cafe') || amenityStr.includes('coffee')) return 'Cafes';
  if (amenityStr.includes('bar')) return 'Bars';
  if (amenityStr.includes('museum')) return 'Museums';
  if (amenityStr.includes('park')) return 'Parks';
  // 3. Infer from description
  const desc = (place.description || '').toLowerCase();
  if (desc.includes('hotel') || desc.includes('accommodat') || desc.includes('rooms & suites')) return 'Hotels';
  if (desc.includes('château') || desc.includes('chateau') || desc.includes('castle') || desc.includes('palace')) return 'Attractions';
  if (desc.includes('restaurant') || desc.includes('bistro') || desc.includes('dining')) return 'Restaurants';
  if (desc.includes('café') || desc.includes('cafe') || desc.includes('coffee')) return 'Cafes';
  if (desc.includes('museum') || desc.includes('gallery')) return 'Museums';
  return 'Other';
}
